// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3d4f80a7","102":"5e5957ef","163":"b54eabb3","244":"eea9345b","268":"34ddb570","291":"b1a75508","327":"ba0c711b","453":"50bb185f","796":"11cbab09","901":"7812adb4","921":"3b8e8dc3"}[chunkId] + ".chunk.js";
};